import { styled } from '../../Utilities';
import { ContextualMenuItemBase } from './ContextualMenuItem.base';
import { getItemStyles } from './ContextualMenu.classNames';
/**
 * ContextualMenuItem description
 */
export var ContextualMenuItem = styled(ContextualMenuItemBase, getItemStyles, undefined, {
  scope: 'ContextualMenuItem'
});